import { render, staticRenderFns } from "./BikyConfigFileList.vue?vue&type=template&id=225cf814&scoped=true&"
import script from "./BikyConfigFileList.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigFileList.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigFileList.vue?vue&type=style&index=0&id=225cf814&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225cf814",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
